const countries = () => {
  let countries = [
    {
      country_name: "USA",
      currency_code: "USD",
      dialog_title: "The US",
      full_country_name: "United States",
      geo: "US",
      human_country: "US",
      locale: "en-US",
      site_country: "us",
      url: "jewlr.com",
    },
    {
      country_name: "Canada",
      currency_code: "CAD",
      dialog_title: "Canada",
      full_country_name: "Canada",
      geo: "CA",
      human_country: "CA",
      locale: "en-CA",
      site_country: "ca",
      url: "jewlr.com/ca",
    },
    {
      country_name: "Australia",
      currency_code: "AUD",
      dialog_title: "Australia",
      full_country_name: "Australia",
      geo: "AU",
      human_country: "AU",
      locale: "en-AU",
      site_country: "au",
      url: "jewlr.com/au",
    },
    {
      country_name: "United Kingdom",
      currency_code: "GBP",
      dialog_title: "The UK",
      full_country_name: "United Kingdom",
      geo: "GB",
      human_country: "UK",
      locale: "en-GB",
      site_country: "uk",
      url: "jewlr.com/uk",
    },
  ]
  if (sl.config.global_e_new_countries) {
    countries = [
      ...countries,
      {
        country_name: "Germany",
        currency_code: "EUR",
        dialog_title: "Germany",
        full_country_name: "Germany",
        geo: "DE",
        human_country: "DE",
        locale: "de-DE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Hong Kong",
        currency_code: "HKD",
        dialog_title: "Hong Kong",
        full_country_name: "Hong Kong",
        geo: "HK",
        human_country: "HK",
        locale: "en-HK",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Italy",
        currency_code: "EUR",
        dialog_title: "Italy",
        full_country_name: "Italy",
        geo: "IT",
        human_country: "IT",
        locale: "it-IT",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Japan",
        currency_code: "JPY",
        dialog_title: "Japan",
        full_country_name: "Japan",
        geo: "JP",
        human_country: "JP",
        locale: "ja-JP",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Poland",
        currency_code: "PLN",
        dialog_title: "Poland",
        full_country_name: "Poland",
        geo: "PL",
        human_country: "PL",
        locale: "pl-PL",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Albania",
        currency_code: "ALL",
        dialog_title: "Albania",
        full_country_name: "Albania",
        geo: "AL",
        human_country: "AL",
        locale: "sq-AL",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Algeria",
        currency_code: "DZD",
        dialog_title: "Algeria",
        full_country_name: "Algeria",
        geo: "DZ",
        human_country: "DZ",
        locale: "ar-DZ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Andorra",
        currency_code: "EUR",
        dialog_title: "Andorra",
        full_country_name: "Andorra",
        geo: "AD",
        human_country: "AD",
        locale: "ca-AD",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Angola",
        currency_code: "AOA",
        dialog_title: "Angola",
        full_country_name: "Angola",
        geo: "AO",
        human_country: "AO",
        locale: "pt-AO",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Anguilla",
        currency_code: "XCD",
        dialog_title: "Anguilla",
        full_country_name: "Anguilla",
        geo: "AI",
        human_country: "AI",
        locale: "en-AI",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Antigua and Barbuda",
        currency_code: "XCD",
        dialog_title: "Antigua and Barbuda",
        full_country_name: "Antigua and Barbuda",
        geo: "AG",
        human_country: "AG",
        locale: "en-AG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Argentina",
        currency_code: "ARS",
        dialog_title: "Argentina",
        full_country_name: "Argentina",
        geo: "AR",
        human_country: "AR",
        locale: "es-AR",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Armenia",
        currency_code: "AMD",
        dialog_title: "Armenia",
        full_country_name: "Armenia",
        geo: "AM",
        human_country: "AM",
        locale: "hy-AM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Aruba",
        currency_code: "AWG",
        dialog_title: "Aruba",
        full_country_name: "Aruba",
        geo: "AW",
        human_country: "AW",
        locale: "nl-AW",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Austria",
        currency_code: "EUR",
        dialog_title: "Austria",
        full_country_name: "Austria",
        geo: "AT",
        human_country: "AT",
        locale: "de-AT",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Azerbaijan",
        currency_code: "AZN",
        dialog_title: "Azerbaijan",
        full_country_name: "Azerbaijan",
        geo: "AZ",
        human_country: "AZ",
        locale: "az-Latn-AZ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Bahamas",
        currency_code: "BSD",
        dialog_title: "Bahamas",
        full_country_name: "Bahamas",
        geo: "BS",
        human_country: "BS",
        locale: "en-BS",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Bahrain",
        currency_code: "BHD",
        dialog_title: "Bahrain",
        full_country_name: "Bahrain",
        geo: "BH",
        human_country: "BH",
        locale: "ar-BH",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Bangladesh",
        currency_code: "BDT",
        dialog_title: "Bangladesh",
        full_country_name: "Bangladesh",
        geo: "BD",
        human_country: "BD",
        locale: "bn-BD",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Barbados",
        currency_code: "BBD",
        dialog_title: "Barbados",
        full_country_name: "Barbados",
        geo: "BB",
        human_country: "BB",
        locale: "en-BB",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Belgium",
        currency_code: "EUR",
        dialog_title: "Belgium",
        full_country_name: "Belgium",
        geo: "BE",
        human_country: "BE",
        locale: "nl-BE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Belize",
        currency_code: "BZD",
        dialog_title: "Belize",
        full_country_name: "Belize",
        geo: "BZ",
        human_country: "BZ",
        locale: "en-BZ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Benin",
        currency_code: "XOF",
        dialog_title: "Benin",
        full_country_name: "Benin",
        geo: "BJ",
        human_country: "BJ",
        locale: "fr-BJ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Bermuda",
        currency_code: "BMD",
        dialog_title: "Bermuda",
        full_country_name: "Bermuda",
        geo: "BM",
        human_country: "BM",
        locale: "en-BM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Bolivia",
        currency_code: "BOB",
        dialog_title: "Bolivia",
        full_country_name: "Bolivia",
        geo: "BO",
        human_country: "BO",
        locale: "es-BO",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Bosnia and Herzegovina",
        currency_code: "BAM",
        dialog_title: "Bosnia and Herzegovina",
        full_country_name: "Bosnia and Herzegovina",
        geo: "BA",
        human_country: "BA",
        locale: "bs-BA",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Botswana",
        currency_code: "BWP",
        dialog_title: "Botswana",
        full_country_name: "Botswana",
        geo: "BW",
        human_country: "BW",
        locale: "en-BW",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Brunei Darussalam",
        currency_code: "BND",
        dialog_title: "Brunei Darussalam",
        full_country_name: "Brunei Darussalam",
        geo: "BN",
        human_country: "BN",
        locale: "ms-BN",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Bulgaria",
        currency_code: "BGN",
        dialog_title: "Bulgaria",
        full_country_name: "Bulgaria",
        geo: "BG",
        human_country: "BG",
        locale: "bg-BG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Burkina Faso",
        currency_code: "XOF",
        dialog_title: "Burkina Faso",
        full_country_name: "Burkina Faso",
        geo: "BF",
        human_country: "BF",
        locale: "fr-BF",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Burundi",
        currency_code: "BIF",
        dialog_title: "Burundi",
        full_country_name: "Burundi",
        geo: "BI",
        human_country: "BI",
        locale: "rn-BI",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Cambodia",
        currency_code: "KHR",
        dialog_title: "Cambodia",
        full_country_name: "Cambodia",
        geo: "KH",
        human_country: "KH",
        locale: "km-KH",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Cameroon",
        currency_code: "XAF",
        dialog_title: "Cameroon",
        full_country_name: "Cameroon",
        geo: "CM",
        human_country: "CM",
        locale: "fr-CM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Cape Verde",
        currency_code: "CVE",
        dialog_title: "Cape Verde",
        full_country_name: "Cape Verde",
        geo: "CV",
        human_country: "CV",
        locale: "pt-CV",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Cayman Islands",
        currency_code: "KYD",
        dialog_title: "Cayman Islands",
        full_country_name: "Cayman Islands",
        geo: "KY",
        human_country: "KY",
        locale: "en-KY",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Chad",
        currency_code: "XAF",
        dialog_title: "Chad",
        full_country_name: "Chad",
        geo: "TD",
        human_country: "TD",
        locale: "fr-TD",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Chile",
        currency_code: "CLP",
        dialog_title: "Chile",
        full_country_name: "Chile",
        geo: "CL",
        human_country: "CL",
        locale: "es-CL",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "China",
        currency_code: "CNY",
        dialog_title: "China",
        full_country_name: "China",
        geo: "CN",
        human_country: "CN",
        locale: "zh-CN",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Colombia",
        currency_code: "COP",
        dialog_title: "Colombia",
        full_country_name: "Colombia",
        geo: "CO",
        human_country: "CO",
        locale: "es-CO",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Comoros",
        currency_code: "KMF",
        dialog_title: "Comoros",
        full_country_name: "Comoros",
        geo: "KM",
        human_country: "KM",
        locale: "ar-KM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Cook Islands",
        currency_code: "NZD",
        dialog_title: "Cook Islands",
        full_country_name: "Cook Islands",
        geo: "CK",
        human_country: "CK",
        locale: "en-CK",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Costa Rica",
        currency_code: "CRC",
        dialog_title: "Costa Rica",
        full_country_name: "Costa Rica",
        geo: "CR",
        human_country: "CR",
        locale: "es-CR",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Cote D'Ivoire (Ivory Coast)",
        currency_code: "XOF",
        dialog_title: "Cote D'Ivoire (Ivory Coast)",
        full_country_name: "Cote D'Ivoire (Ivory Coast)",
        geo: "CI",
        human_country: "CI",
        locale: "fr-CI",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Croatia",
        currency_code: "EUR",
        dialog_title: "Croatia",
        full_country_name: "Croatia",
        geo: "HR",
        human_country: "HR",
        locale: "hr-HR",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Curacao",
        currency_code: "ANG",
        dialog_title: "Curacao",
        full_country_name: "Curacao",
        geo: "CW",
        human_country: "CW",
        locale: "nl-CW",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Cyprus",
        currency_code: "EUR",
        dialog_title: "Cyprus",
        full_country_name: "Cyprus",
        geo: "CY",
        human_country: "CY",
        locale: "el-CY",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Czech Republic",
        currency_code: "CZK",
        dialog_title: "Czech Republic",
        full_country_name: "Czech Republic",
        geo: "CZ",
        human_country: "CZ",
        locale: "cs-CZ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Denmark",
        currency_code: "DKK",
        dialog_title: "Denmark",
        full_country_name: "Denmark",
        geo: "DK",
        human_country: "DK",
        locale: "da-DK",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Djibouti",
        currency_code: "DJF",
        dialog_title: "Djibouti",
        full_country_name: "Djibouti",
        geo: "DJ",
        human_country: "DJ",
        locale: "fr-DJ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Dominica",
        currency_code: "XCD",
        dialog_title: "Dominica",
        full_country_name: "Dominica",
        geo: "DM",
        human_country: "DM",
        locale: "en-DM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Dominican Republic",
        currency_code: "DOP",
        dialog_title: "Dominican Republic",
        full_country_name: "Dominican Republic",
        geo: "DO",
        human_country: "DO",
        locale: "es-DO",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "East Timor",
        currency_code: "USD",
        dialog_title: "East Timor",
        full_country_name: "East Timor",
        geo: "TL",
        human_country: "TL",
        locale: "pt-TL",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Ecuador",
        currency_code: "USD",
        dialog_title: "Ecuador",
        full_country_name: "Ecuador",
        geo: "EC",
        human_country: "EC",
        locale: "es-EC",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Egypt",
        currency_code: "EGP",
        dialog_title: "Egypt",
        full_country_name: "Egypt",
        geo: "EG",
        human_country: "EG",
        locale: "ar-EG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "El Salvador",
        currency_code: "USD",
        dialog_title: "El Salvador",
        full_country_name: "El Salvador",
        geo: "SV",
        human_country: "SV",
        locale: "es-SV",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Equatorial Guinea",
        currency_code: "XAF",
        dialog_title: "Equatorial Guinea",
        full_country_name: "Equatorial Guinea",
        geo: "GQ",
        human_country: "GQ",
        locale: "es-GQ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Estonia",
        currency_code: "EUR",
        dialog_title: "Estonia",
        full_country_name: "Estonia",
        geo: "EE",
        human_country: "EE",
        locale: "et-EE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Ethiopia",
        currency_code: "ETB",
        dialog_title: "Ethiopia",
        full_country_name: "Ethiopia",
        geo: "ET",
        human_country: "ET",
        locale: "am-ET",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Falkland Islands",
        currency_code: "FKP",
        dialog_title: "Falkland Islands",
        full_country_name: "Falkland Islands",
        geo: "FK",
        human_country: "FK",
        locale: "en-FK",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Faroe Islands",
        currency_code: "DKK",
        dialog_title: "Faroe Islands",
        full_country_name: "Faroe Islands",
        geo: "FO",
        human_country: "FO",
        locale: "fo-FO",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Fiji",
        currency_code: "FJD",
        dialog_title: "Fiji",
        full_country_name: "Fiji",
        geo: "FJ",
        human_country: "FJ",
        locale: "en-FJ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Finland",
        currency_code: "EUR",
        dialog_title: "Finland",
        full_country_name: "Finland",
        geo: "FI",
        human_country: "FI",
        locale: "fi-FI",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "France",
        currency_code: "EUR",
        dialog_title: "France",
        full_country_name: "France",
        geo: "FR",
        human_country: "FR",
        locale: "fr-FR",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "French Guiana",
        currency_code: "EUR",
        dialog_title: "French Guiana",
        full_country_name: "French Guiana",
        geo: "GF",
        human_country: "GF",
        locale: "fr-GF",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "French Polynesia",
        currency_code: "XPF",
        dialog_title: "French Polynesia",
        full_country_name: "French Polynesia",
        geo: "PF",
        human_country: "PF",
        locale: "fr-PF",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Gabon",
        currency_code: "XAF",
        dialog_title: "Gabon",
        full_country_name: "Gabon",
        geo: "GA",
        human_country: "GA",
        locale: "fr-GA",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Gambia",
        currency_code: "GMD",
        dialog_title: "Gambia",
        full_country_name: "Gambia",
        geo: "GM",
        human_country: "GM",
        locale: "en-GM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Georgia",
        currency_code: "GEL",
        dialog_title: "Georgia",
        full_country_name: "Georgia",
        geo: "GE",
        human_country: "GE",
        locale: "ka-GE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Ghana",
        currency_code: "GHS",
        dialog_title: "Ghana",
        full_country_name: "Ghana",
        geo: "GH",
        human_country: "GH",
        locale: "en-GH",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Gibraltar",
        currency_code: "GIP",
        dialog_title: "Gibraltar",
        full_country_name: "Gibraltar",
        geo: "GI",
        human_country: "GI",
        locale: "en-GI",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Greece",
        currency_code: "EUR",
        dialog_title: "Greece",
        full_country_name: "Greece",
        geo: "GR",
        human_country: "GR",
        locale: "el-GR",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Greenland",
        currency_code: "DKK",
        dialog_title: "Greenland",
        full_country_name: "Greenland",
        geo: "GL",
        human_country: "GL",
        locale: "kl-GL",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Grenada",
        currency_code: "XCD",
        dialog_title: "Grenada",
        full_country_name: "Grenada",
        geo: "GD",
        human_country: "GD",
        locale: "en-GD",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Guadeloupe",
        currency_code: "EUR",
        dialog_title: "Guadeloupe",
        full_country_name: "Guadeloupe",
        geo: "GP",
        human_country: "GP",
        locale: "fr-GP",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Guatemala",
        currency_code: "GTQ",
        dialog_title: "Guatemala",
        full_country_name: "Guatemala",
        geo: "GT",
        human_country: "GT",
        locale: "es-GT",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Guernsey",
        currency_code: "GBP",
        dialog_title: "Guernsey",
        full_country_name: "Guernsey",
        geo: "GG",
        human_country: "GG",
        locale: "en-GG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Guinea",
        currency_code: "GNF",
        dialog_title: "Guinea",
        full_country_name: "Guinea",
        geo: "GN",
        human_country: "GN",
        locale: "fr-GN",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Guinea-Bissau",
        currency_code: "XOF",
        dialog_title: "Guinea-Bissau",
        full_country_name: "Guinea-Bissau",
        geo: "GW",
        human_country: "GW",
        locale: "pt-GW",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Guyana",
        currency_code: "GYD",
        dialog_title: "Guyana",
        full_country_name: "Guyana",
        geo: "GY",
        human_country: "GY",
        locale: "en-GY",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Haiti",
        currency_code: "HTG",
        dialog_title: "Haiti",
        full_country_name: "Haiti",
        geo: "HT",
        human_country: "HT",
        locale: "fr-HT",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Honduras",
        currency_code: "HNL",
        dialog_title: "Honduras",
        full_country_name: "Honduras",
        geo: "HN",
        human_country: "HN",
        locale: "es-HN",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Hungary",
        currency_code: "HUF",
        dialog_title: "Hungary",
        full_country_name: "Hungary",
        geo: "HU",
        human_country: "HU",
        locale: "hu-HU",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Iceland",
        currency_code: "ISK",
        dialog_title: "Iceland",
        full_country_name: "Iceland",
        geo: "IS",
        human_country: "IS",
        locale: "is-IS",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Indonesia",
        currency_code: "IDR",
        dialog_title: "Indonesia",
        full_country_name: "Indonesia",
        geo: "ID",
        human_country: "ID",
        locale: "id-ID",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Ireland (Republic of)",
        currency_code: "EUR",
        dialog_title: "Ireland (Republic of)",
        full_country_name: "Ireland (Republic of)",
        geo: "IE",
        human_country: "IE",
        locale: "en-IE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Isle of Man",
        currency_code: "GBP",
        dialog_title: "Isle of Man",
        full_country_name: "Isle of Man",
        geo: "IM",
        human_country: "IM",
        locale: "en-IM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Israel",
        currency_code: "ILS",
        dialog_title: "Israel",
        full_country_name: "Israel",
        geo: "IL",
        human_country: "IL",
        locale: "he-IL",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Jamaica",
        currency_code: "JMD",
        dialog_title: "Jamaica",
        full_country_name: "Jamaica",
        geo: "JM",
        human_country: "JM",
        locale: "en-JM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Jersey",
        currency_code: "GBP",
        dialog_title: "Jersey",
        full_country_name: "Jersey",
        geo: "JE",
        human_country: "JE",
        locale: "en-JE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Jordan",
        currency_code: "JOD",
        dialog_title: "Jordan",
        full_country_name: "Jordan",
        geo: "JO",
        human_country: "JO",
        locale: "ar-JO",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Kazakhstan",
        currency_code: "KZT",
        dialog_title: "Kazakhstan",
        full_country_name: "Kazakhstan",
        geo: "KZ",
        human_country: "KZ",
        locale: "kk-KZ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Kenya",
        currency_code: "KES",
        dialog_title: "Kenya",
        full_country_name: "Kenya",
        geo: "KE",
        human_country: "KE",
        locale: "en-KE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Kiribati",
        currency_code: "AUD",
        dialog_title: "Kiribati",
        full_country_name: "Kiribati",
        geo: "KI",
        human_country: "KI",
        locale: "en-KI",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Korea (South)",
        currency_code: "KRW",
        dialog_title: "Korea (South)",
        full_country_name: "Korea (South)",
        geo: "KR",
        human_country: "KR",
        locale: "ko-KR",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Kyrgyzstan",
        currency_code: "KGS",
        dialog_title: "Kyrgyzstan",
        full_country_name: "Kyrgyzstan",
        geo: "KG",
        human_country: "KG",
        locale: "ky-KG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Laos",
        currency_code: "LAK",
        dialog_title: "Laos",
        full_country_name: "Laos",
        geo: "LA",
        human_country: "LA",
        locale: "lo-LA",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Latvia",
        currency_code: "EUR",
        dialog_title: "Latvia",
        full_country_name: "Latvia",
        geo: "LV",
        human_country: "LV",
        locale: "lv-LV",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Lebanon",
        currency_code: "LBP",
        dialog_title: "Lebanon",
        full_country_name: "Lebanon",
        geo: "LB",
        human_country: "LB",
        locale: "ar-LB",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Lesotho",
        currency_code: "LSL",
        dialog_title: "Lesotho",
        full_country_name: "Lesotho",
        geo: "LS",
        human_country: "LS",
        locale: "en-LS",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Liberia",
        currency_code: "LRD",
        dialog_title: "Liberia",
        full_country_name: "Liberia",
        geo: "LR",
        human_country: "LR",
        locale: "en-LR",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Liechtenstein",
        currency_code: "CHF",
        dialog_title: "Liechtenstein",
        full_country_name: "Liechtenstein",
        geo: "LI",
        human_country: "LI",
        locale: "de-LI",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Lithuania",
        currency_code: "EUR",
        dialog_title: "Lithuania",
        full_country_name: "Lithuania",
        geo: "LT",
        human_country: "LT",
        locale: "lt-LT",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Luxembourg",
        currency_code: "EUR",
        dialog_title: "Luxembourg",
        full_country_name: "Luxembourg",
        geo: "LU",
        human_country: "LU",
        locale: "lb-LU",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Macau",
        currency_code: "MOP",
        dialog_title: "Macau",
        full_country_name: "Macau",
        geo: "MO",
        human_country: "MO",
        locale: "zh-MO",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Madagascar",
        currency_code: "MGA",
        dialog_title: "Madagascar",
        full_country_name: "Madagascar",
        geo: "MG",
        human_country: "MG",
        locale: "fr-MG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Malawi",
        currency_code: "MWK",
        dialog_title: "Malawi",
        full_country_name: "Malawi",
        geo: "MW",
        human_country: "MW",
        locale: "en-MW",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Malaysia",
        currency_code: "MYR",
        dialog_title: "Malaysia",
        full_country_name: "Malaysia",
        geo: "MY",
        human_country: "MY",
        locale: "ms-MY",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Maldives",
        currency_code: "MVR",
        dialog_title: "Maldives",
        full_country_name: "Maldives",
        geo: "MV",
        human_country: "MV",
        locale: "dv-MV",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Malta",
        currency_code: "EUR",
        dialog_title: "Malta",
        full_country_name: "Malta",
        geo: "MT",
        human_country: "MT",
        locale: "mt-MT",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Martinique",
        currency_code: "EUR",
        dialog_title: "Martinique",
        full_country_name: "Martinique",
        geo: "MQ",
        human_country: "MQ",
        locale: "fr-MQ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Mauritania",
        currency_code: "MRU",
        dialog_title: "Mauritania",
        full_country_name: "Mauritania",
        geo: "MR",
        human_country: "MR",
        locale: "ar-MR",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Mauritius",
        currency_code: "MUR",
        dialog_title: "Mauritius",
        full_country_name: "Mauritius",
        geo: "MU",
        human_country: "MU",
        locale: "en-MU",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Mayotte",
        currency_code: "EUR",
        dialog_title: "Mayotte",
        full_country_name: "Mayotte",
        geo: "YT",
        human_country: "YT",
        locale: "fr-YT",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Moldova",
        currency_code: "MDL",
        dialog_title: "Moldova",
        full_country_name: "Moldova",
        geo: "MD",
        human_country: "MD",
        locale: "ro-MD",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Monaco",
        currency_code: "EUR",
        dialog_title: "Monaco",
        full_country_name: "Monaco",
        geo: "MC",
        human_country: "MC",
        locale: "fr-MC",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Mongolia",
        currency_code: "MNT",
        dialog_title: "Mongolia",
        full_country_name: "Mongolia",
        geo: "MN",
        human_country: "MN",
        locale: "mn-MN",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Montenegro",
        currency_code: "EUR",
        dialog_title: "Montenegro",
        full_country_name: "Montenegro",
        geo: "ME",
        human_country: "ME",
        locale: "srp-ME",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Montserrat",
        currency_code: "XCD",
        dialog_title: "Montserrat",
        full_country_name: "Montserrat",
        geo: "MS",
        human_country: "MS",
        locale: "en-MS",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Mozambique",
        currency_code: "MZN",
        dialog_title: "Mozambique",
        full_country_name: "Mozambique",
        geo: "MZ",
        human_country: "MZ",
        locale: "pt-MZ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Namibia",
        currency_code: "NAD",
        dialog_title: "Namibia",
        full_country_name: "Namibia",
        geo: "NA",
        human_country: "NA",
        locale: "en-NA",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Nauru",
        currency_code: "AUD",
        dialog_title: "Nauru",
        full_country_name: "Nauru",
        geo: "NR",
        human_country: "NR",
        locale: "en-NR",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Nepal",
        currency_code: "NPR",
        dialog_title: "Nepal",
        full_country_name: "Nepal",
        geo: "NP",
        human_country: "NP",
        locale: "ne-NP",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Netherlands",
        currency_code: "EUR",
        dialog_title: "Netherlands",
        full_country_name: "Netherlands",
        geo: "NL",
        human_country: "NL",
        locale: "nl-NL",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "New Caledonia",
        currency_code: "XPF",
        dialog_title: "New Caledonia",
        full_country_name: "New Caledonia",
        geo: "NC",
        human_country: "NC",
        locale: "fr-NC",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "New Zealand",
        currency_code: "NZD",
        dialog_title: "New Zealand",
        full_country_name: "New Zealand",
        geo: "NZ",
        human_country: "NZ",
        locale: "en-NZ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Nicaragua",
        currency_code: "NIO",
        dialog_title: "Nicaragua",
        full_country_name: "Nicaragua",
        geo: "NI",
        human_country: "NI",
        locale: "es-NI",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Nigeria",
        currency_code: "NGN",
        dialog_title: "Nigeria",
        full_country_name: "Nigeria",
        geo: "NG",
        human_country: "NG",
        locale: "en-NG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Niue",
        currency_code: "NZD",
        dialog_title: "Niue",
        full_country_name: "Niue",
        geo: "NU",
        human_country: "NU",
        locale: "en-NU",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "North Macedonia",
        currency_code: "MKD",
        dialog_title: "North Macedonia",
        full_country_name: "North Macedonia",
        geo: "MK",
        human_country: "MK",
        locale: "mk-MK",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Norway",
        currency_code: "NOK",
        dialog_title: "Norway",
        full_country_name: "Norway",
        geo: "NO",
        human_country: "NO",
        locale: "nb-NO",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Oman",
        currency_code: "OMR",
        dialog_title: "Oman",
        full_country_name: "Oman",
        geo: "OM",
        human_country: "OM",
        locale: "ar-OM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Pakistan",
        currency_code: "PKR",
        dialog_title: "Pakistan",
        full_country_name: "Pakistan",
        geo: "PK",
        human_country: "PK",
        locale: "en-PK",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Panama",
        currency_code: "PAB",
        dialog_title: "Panama",
        full_country_name: "Panama",
        geo: "PA",
        human_country: "PA",
        locale: "es-PA",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Papua New Guinea",
        currency_code: "PGK",
        dialog_title: "Papua New Guinea",
        full_country_name: "Papua New Guinea",
        geo: "PG",
        human_country: "PG",
        locale: "en-PG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Paraguay",
        currency_code: "PYG",
        dialog_title: "Paraguay",
        full_country_name: "Paraguay",
        geo: "PY",
        human_country: "PY",
        locale: "es-PY",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Peru",
        currency_code: "PEN",
        dialog_title: "Peru",
        full_country_name: "Peru",
        geo: "PE",
        human_country: "PE",
        locale: "es-PE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Philippines",
        currency_code: "PHP",
        dialog_title: "Philippines",
        full_country_name: "Philippines",
        geo: "PH",
        human_country: "PH",
        locale: "en-PH",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Qatar",
        currency_code: "QAR",
        dialog_title: "Qatar",
        full_country_name: "Qatar",
        geo: "QA",
        human_country: "QA",
        locale: "ar-QA",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Reunion",
        currency_code: "EUR",
        dialog_title: "Reunion",
        full_country_name: "Reunion",
        geo: "RE",
        human_country: "RE",
        locale: "fr-RE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Romania",
        currency_code: "RON",
        dialog_title: "Romania",
        full_country_name: "Romania",
        geo: "RO",
        human_country: "RO",
        locale: "ro-RO",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Rwanda",
        currency_code: "RWF",
        dialog_title: "Rwanda",
        full_country_name: "Rwanda",
        geo: "RW",
        human_country: "RW",
        locale: "rw-RW",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Saint Lucia",
        currency_code: "XCD",
        dialog_title: "Saint Lucia",
        full_country_name: "Saint Lucia",
        geo: "LC",
        human_country: "LC",
        locale: "en-LC",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Saint Vincent & the Grenadines",
        currency_code: "XCD",
        dialog_title: "Saint Vincent & the Grenadines",
        full_country_name: "Saint Vincent & the Grenadines",
        geo: "VC",
        human_country: "VC",
        locale: "en-VC",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Samoa",
        currency_code: "WST",
        dialog_title: "Samoa",
        full_country_name: "Samoa",
        geo: "WS",
        human_country: "WS",
        locale: "sm-WS",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "San Marino",
        currency_code: "EUR",
        dialog_title: "San Marino",
        full_country_name: "San Marino",
        geo: "SM",
        human_country: "SM",
        locale: "it-SM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Sao Tome and Principe",
        currency_code: "STN",
        dialog_title: "Sao Tome and Principe",
        full_country_name: "Sao Tome and Principe",
        geo: "ST",
        human_country: "ST",
        locale: "pt-ST",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Saudi Arabia",
        currency_code: "SAR",
        dialog_title: "Saudi Arabia",
        full_country_name: "Saudi Arabia",
        geo: "SA",
        human_country: "SA",
        locale: "ar-SA",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Senegal",
        currency_code: "XOF",
        dialog_title: "Senegal",
        full_country_name: "Senegal",
        geo: "SN",
        human_country: "SN",
        locale: "fr-SN",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Serbia",
        currency_code: "RSD",
        dialog_title: "Serbia",
        full_country_name: "Serbia",
        geo: "RS",
        human_country: "RS",
        locale: "sr-RS",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Seychelles",
        currency_code: "SCR",
        dialog_title: "Seychelles",
        full_country_name: "Seychelles",
        geo: "SC",
        human_country: "SC",
        locale: "en-SC",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Sierra Leone",
        currency_code: "SLL",
        dialog_title: "Sierra Leone",
        full_country_name: "Sierra Leone",
        geo: "SL",
        human_country: "SL",
        locale: "en-SL",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Singapore",
        currency_code: "SGD",
        dialog_title: "Singapore",
        full_country_name: "Singapore",
        geo: "SG",
        human_country: "SG",
        locale: "en-SG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Sint Maarten",
        currency_code: "ANG",
        dialog_title: "Sint Maarten",
        full_country_name: "Sint Maarten",
        geo: "SX",
        human_country: "SX",
        locale: "nl-SX",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Slovak Republic",
        currency_code: "EUR",
        dialog_title: "Slovak Republic",
        full_country_name: "Slovak Republic",
        geo: "SK",
        human_country: "SK",
        locale: "sk-SK",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Slovenia",
        currency_code: "EUR",
        dialog_title: "Slovenia",
        full_country_name: "Slovenia",
        geo: "SI",
        human_country: "SI",
        locale: "sl-SI",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Solomon Islands",
        currency_code: "SBD",
        dialog_title: "Solomon Islands",
        full_country_name: "Solomon Islands",
        geo: "SB",
        human_country: "SB",
        locale: "en-SB",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "South Africa",
        currency_code: "ZAR",
        dialog_title: "South Africa",
        full_country_name: "South Africa",
        geo: "ZA",
        human_country: "ZA",
        locale: "en-ZA",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Spain",
        currency_code: "EUR",
        dialog_title: "Spain",
        full_country_name: "Spain",
        geo: "ES",
        human_country: "ES",
        locale: "es-ES",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Sri Lanka",
        currency_code: "LKR",
        dialog_title: "Sri Lanka",
        full_country_name: "Sri Lanka",
        geo: "LK",
        human_country: "LK",
        locale: "si-LK",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "St Barthelemy",
        currency_code: "EUR",
        dialog_title: "St Barthelemy",
        full_country_name: "St Barthelemy",
        geo: "BL",
        human_country: "BL",
        locale: "fr-BL",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "St Martin",
        currency_code: "EUR",
        dialog_title: "St Martin",
        full_country_name: "St Martin",
        geo: "MF",
        human_country: "MF",
        locale: "fr-MF",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "St. Helena",
        currency_code: "SHP",
        dialog_title: "St. Helena",
        full_country_name: "St. Helena",
        geo: "SH",
        human_country: "SH",
        locale: "en-SH",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Suriname",
        currency_code: "SRD",
        dialog_title: "Suriname",
        full_country_name: "Suriname",
        geo: "SR",
        human_country: "SR",
        locale: "nl-SR",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Swaziland",
        currency_code: "SZL",
        dialog_title: "Swaziland",
        full_country_name: "Swaziland",
        geo: "SZ",
        human_country: "SZ",
        locale: "en-SZ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Sweden",
        currency_code: "SEK",
        dialog_title: "Sweden",
        full_country_name: "Sweden",
        geo: "SE",
        human_country: "SE",
        locale: "sv-SE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Taiwan",
        currency_code: "TWD",
        dialog_title: "Taiwan",
        full_country_name: "Taiwan",
        geo: "TW",
        human_country: "TW",
        locale: "zh-TW",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Tanzania",
        currency_code: "TZS",
        dialog_title: "Tanzania",
        full_country_name: "Tanzania",
        geo: "TZ",
        human_country: "TZ",
        locale: "sw-TZ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Thailand",
        currency_code: "THB",
        dialog_title: "Thailand",
        full_country_name: "Thailand",
        geo: "TH",
        human_country: "TH",
        locale: "th-TH",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Togo",
        currency_code: "XOF",
        dialog_title: "Togo",
        full_country_name: "Togo",
        geo: "TG",
        human_country: "TG",
        locale: "fr-TG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Tonga",
        currency_code: "TOP",
        dialog_title: "Tonga",
        full_country_name: "Tonga",
        geo: "TO",
        human_country: "TO",
        locale: "en-TO",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Trinidad and Tobago",
        currency_code: "TTD",
        dialog_title: "Trinidad and Tobago",
        full_country_name: "Trinidad and Tobago",
        geo: "TT",
        human_country: "TT",
        locale: "en-TT",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Tunisia",
        currency_code: "TND",
        dialog_title: "Tunisia",
        full_country_name: "Tunisia",
        geo: "TN",
        human_country: "TN",
        locale: "ar-TN",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Turkmenistan",
        currency_code: "TMT",
        dialog_title: "Turkmenistan",
        full_country_name: "Turkmenistan",
        geo: "TM",
        human_country: "TM",
        locale: "tk-TM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Turks and Caicos Islands",
        currency_code: "USD",
        dialog_title: "Turks and Caicos Islands",
        full_country_name: "Turks and Caicos Islands",
        geo: "TC",
        human_country: "TC",
        locale: "en-TC",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Tuvalu",
        currency_code: "AUD",
        dialog_title: "Tuvalu",
        full_country_name: "Tuvalu",
        geo: "TV",
        human_country: "TV",
        locale: "en-TV",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Uganda",
        currency_code: "UGX",
        dialog_title: "Uganda",
        full_country_name: "Uganda",
        geo: "UG",
        human_country: "UG",
        locale: "en-UG",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "United Arab Emirates",
        currency_code: "AED",
        dialog_title: "United Arab Emirates",
        full_country_name: "United Arab Emirates",
        geo: "AE",
        human_country: "AE",
        locale: "ar-AE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Uruguay",
        currency_code: "UYU",
        dialog_title: "Uruguay",
        full_country_name: "Uruguay",
        geo: "UY",
        human_country: "UY",
        locale: "es-UY",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Uzbekistan",
        currency_code: "UZS",
        dialog_title: "Uzbekistan",
        full_country_name: "Uzbekistan",
        geo: "UZ",
        human_country: "UZ",
        locale: "uz-UZ",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Vanuatu",
        currency_code: "VUV",
        dialog_title: "Vanuatu",
        full_country_name: "Vanuatu",
        geo: "VU",
        human_country: "VU",
        locale: "bi-VU",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Vatican City State (Holy See)",
        currency_code: "EUR",
        dialog_title: "Vatican City State (Holy See)",
        full_country_name: "Vatican City State (Holy See)",
        geo: "VA",
        human_country: "VA",
        locale: "it-VA",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Venezuela",
        currency_code: "VES",
        dialog_title: "Venezuela",
        full_country_name: "Venezuela",
        geo: "VE",
        human_country: "VE",
        locale: "es-VE",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Vietnam",
        currency_code: "VND",
        dialog_title: "Vietnam",
        full_country_name: "Vietnam",
        geo: "VN",
        human_country: "VN",
        locale: "vi-VN",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Wallis and Futuna Islands",
        currency_code: "XPF",
        dialog_title: "Wallis and Futuna Islands",
        full_country_name: "Wallis and Futuna Islands",
        geo: "WF",
        human_country: "WF",
        locale: "fr-WF",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Zambia",
        currency_code: "ZMW",
        dialog_title: "Zambia",
        full_country_name: "Zambia",
        geo: "ZM",
        human_country: "ZM",
        locale: "en-ZM",
        site_country: "int",
        url: "jewlr.com/int",
      },
      {
        country_name: "Zimbabwe",
        currency_code: "ZWL",
        dialog_title: "Zimbabwe",
        full_country_name: "Zimbabwe",
        geo: "ZW",
        human_country: "ZW",
        locale: "en-ZW",
        site_country: "int",
        url: "jewlr.com/int",
      },
    ]
  }
  return countries
}

export default countries
